module.exports = __webpack_public_path__ + "img/edit.384c84e6.svg";